import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { StatusBadge } from "../../components/Badge";
import type { MailClientMatch } from "../../api/types";

// 讀信側欄「對應客戶」(規格 §2.6):寄件人(寄件備份看收件人)的信箱對到的客戶,
// 與該客戶最近的報價單(含狀態)。比對在後端(`app/mailbox/clients.py`),這裡只顯示;
// 報價單用站內路由開 `/quotes/:id`,不另開視窗。

export function ClientPanel({ clients }: { clients: MailClientMatch[] | undefined }) {
  const list = clients ?? [];
  if (list.length === 0) return null;
  return (
    <aside
      aria-label="對應客戶"
      className="flex flex-col gap-3 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface-2)] p-3 print:hidden"
    >
      {list.map((client) => (
        <section key={client.company_id} className="flex flex-col gap-1.5">
          <h4 className="m-0 flex items-center gap-1.5 text-sm font-semibold text-[var(--text)]">
            <Building2 aria-hidden="true" size={14} />
            {client.company_name}
          </h4>
          {client.quotes.length > 0 ? (
            <ul className="m-0 flex flex-col gap-1 p-0">
              {client.quotes.map((quote) => (
                <li key={quote.id} className="flex list-none flex-wrap items-center gap-1.5 text-sm">
                  <Link
                    to={`/quotes/${quote.id}`}
                    className="min-w-0 text-[var(--accent-hover)] underline-offset-2 hover:underline"
                  >
                    <span className="tabular">{quote.quote_no}</span> {quote.title}
                  </Link>
                  <StatusBadge status={quote.status} />
                </li>
              ))}
            </ul>
          ) : (
            <p className="m-0 text-xs text-[var(--text-3)]">這家客戶還沒有報價單。</p>
          )}
        </section>
      ))}
    </aside>
  );
}
